import React, { useEffect, useState } from 'react'
import Navbar from '../components/Sidebar'
import Header from '../components/HeaderCar'
import { Link } from "react-router-dom"
import CalendarData from '../components/Calendar.json'
import UpcomingCalendarRow from '../components/UpcomingCalendarRow'
import { LinkIcon } from '../assets/icons'

export default function Home() {
    const [cardComp, setCardComp] = useState(<></>);

    const initData = function () {
        var afterToday = [];
        for (let i = 0; i < CalendarData.length; i++) {
            if (new Date(CalendarData[i].start) >= Date.now()) {
                afterToday.push(CalendarData[i])
            }
        }

        var temp = [];
        temp = afterToday.sort((a, b) => {
            return new Date(a.start) - new Date(b.start)
        })

        var comp = [];
        for (let c = 0; c < temp.length; c++) {
            comp.push(<UpcomingCalendarRow data={temp[c]} key={temp[c].id} />)
        }

        setCardComp(comp)

        if (comp.length < 1) {
            setCardComp(<i>No upcoming events currently</i>)
        }
    }

    useEffect(() => {
        initData();
    }, []);

    return (
        <div>
            <main role="main" className="flex-shrink-0 min-vh-100">
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-6'>
                            <div className="card mb-3">
                                <div className="card-header fw-bold">
                                    2026 Regional Water Plan
                                </div>
                                <div className="card-body">
                                    <p>The Region H 2026 Regional Water Plan (RWP) is now available. <Link to="/PlanningDocs" target="_blank">Click here</Link> for the complete text of the RWP.</p>
                                </div>
                            </div>

                            <div className="card mb-3">
                                <div className="card-header fw-bold">
                                    Vacancy Notices
                                </div>
                                <div className="card-body">
                                    <p>
                                        <a href="https://fnicdn.blob.core.windows.net/regionh/documents/Notice of Vacancy-RHWPG_Small_Business_202602.pdf" target="_blank">
                                            Notice of Vacancy for Region H Water Planning Group Member Representing Small Business <i className='fa-solid fa-link' />
                                        </a>
                                    </p>
                                </div>
                            </div>
                            <div className="card mb-3 d-none">
                                <div className="card-header border-success fw-bold">
                                    Project Request Template
                                </div>
                                <div className="card-body">
                                    <p className="card-text">Written request for project inclusion by sponsors is one of the factors considered in the project prioritization process. If you would like to formally request the inclusion of the projects listed for your organization in the Region H Initially Prepared Regional Water Plan, please
                                        <a href="https://fnicdn.blob.core.windows.net/regionh/documents/RHWPG_Prioritization_Request_Template.pdf" rel="noreferrer" target="_blank"> click here</a> for an example template.</p>
                                </div>
                            </div>
                            <div className="card mb-3">
                                <div className="card-header fw-bold" >
                                    Welcome
                                </div>
                                <div className="card-body">
                                    <p className="card-text">
                                        The Region H website is dedicated to the ongoing public participation between the Region H Water Planning Group and the various stakeholders in the 15-county Region H Water Planning Area.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-6'>
                            <div className="card mb-3">
                                <div className="card-header fw-bold" >
                                    <Link to="/Calendar" style={{ color: "white" }} target="_blank">Calendar <LinkIcon /></Link>
                                </div>
                                <div className="card-body">
                                    <div className="card-text">
                                        {cardComp}
                                    </div>
                                </div>
                            </div>
                            <div className="card mb-3">
                                <div className="card-header fw-bold" >
                                    Region H Water Planning Group (RHWPG) Meeting
                                </div>
                                <div className="card-body">
                                    <p className="card-text">
                                        A meeting of the Region H Water Planning Group (RHWPG) is scheduled for November 4, 2026 at 10:00 AM. The RHWPG is seeking input from the public on the scope of planning activities to be considered during the Seventh Cycle of Regional Water Planning.
                                    </p>
                                    <p>
                                        <a target='_blank' href='https://fnicdn.blob.core.windows.net/regionh/documents/meetings/20261104_RHWPG_Notice_ForPosting.pdf'>
                                            Click here for the meeting notice and information on the associated public comment period.<LinkIcon />
                                        </a>
                                    </p>
                                    <p>
                                        <a target='_blank' href='https://fnicdn.blob.core.windows.net/regionh/documents/meetings/20261104_RHWPG Agenda_Final.pdf'>
                                            Click here for the meeting agenda.<LinkIcon />
                                        </a>
                                    </p>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
            </main>
        </div>
    )
}
